import { Outlet, useOutletContext } from 'react-router';

const WithoutHeaderLayout = () => {
  const context = useOutletContext();
  return (
    <div className="main">
      <Outlet context={context} />
    </div>
  );
};

export default WithoutHeaderLayout;
